class SupraHeader {
  constructor(element) {
    this.header = element;
    this.toggle = element.querySelector("[data-supra-menu-toggle]");
    this.drawer = element.querySelector("[data-supra-menu-drawer]");
    this.closeButton = element.querySelector("[data-supra-menu-close]");
    this.cartTriggers = [
      ...element.querySelectorAll("[data-supra-cart-trigger]"),
    ];
    this.searchTriggers = [
      ...element.querySelectorAll("[data-supra-search-trigger]"),
    ];
    this.searchModal = document.getElementById("search-modal");
    this.megaItems = [...element.querySelectorAll("[data-supra-mega-item]")];
    this.closeTimer = null;

    this.initializeMegaMenus();
    this.initializeSearchModal();

    if (!this.toggle || !this.drawer) return;

    this.toggle.addEventListener("click", () =>
      this.setOpen(this.drawer.hidden),
    );
    this.closeButton?.addEventListener("click", () => this.setOpen(false));
    this.cartTriggers.forEach((trigger) =>
      trigger.addEventListener("click", this.toggleCartDrawer),
    );
    document.addEventListener("theme-drawer:open", this.syncCartTriggers);
    document.addEventListener("theme-drawer:close", this.syncCartTriggers);
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (!this.drawer.hidden) this.setOpen(false);
      this.closeMegaMenus();
    });
    window.addEventListener("resize", () => {
      if (window.matchMedia("(min-width: 1000px)").matches) this.setOpen(false);
      this.updateHeightTokens();
    });

    this.updateHeightTokens();
    this.syncCartTriggers(new Event("init"));
    document.addEventListener("shopify:cart:lines-update", this.syncCartCount);
  }

  initializeSearchModal() {
    this.searchTriggers.forEach((trigger) =>
      trigger.addEventListener("click", this.openSearchModal),
    );
    this.searchModal?.addEventListener("dialog:open", this.syncSearchTriggers);
    this.searchModal?.addEventListener("dialog:close", this.syncSearchTriggers);
  }

  openSearchModal = (event) => {
    event?.preventDefault();
    if (this.drawer && this.toggle) this.setOpen(false);
    this.closeMegaMenus();

    if (this.searchModal && typeof this.searchModal.showDialog === "function") {
      this.searchModal.showDialog();
    }
  };

  syncSearchTriggers = () => {
    const open = Boolean(this.searchModal?.querySelector("dialog")?.open);
    this.searchTriggers.forEach((trigger) =>
      trigger.setAttribute("aria-expanded", String(open)),
    );
  };

  toggleCartDrawer = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    this.setOpen(false);
    const cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer && typeof cartDrawer.toggle === "function") {
      cartDrawer.toggle();
      return;
    }
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
  };

  syncCartTriggers = (event) => {
    if (
      event.target instanceof HTMLElement &&
      event.target.id !== "cart-drawer"
    )
      return;
    const open =
      document.getElementById("cart-drawer")?.hasAttribute("open") || false;
    this.cartTriggers.forEach((trigger) =>
      trigger.setAttribute("aria-expanded", String(open)),
    );
  };

  syncCartCount = (event) => {
    event.promise
      ?.then(({ cart }) => {
        const count = Number(cart?.totalQuantity) || 0;

        this.cartTriggers.forEach((trigger) => {
          if (trigger.classList.contains("supra-header__cart")) {
            let badge = trigger.querySelector(".supra-header__cart-count");
            if (count > 0 && !badge) {
              badge = document.createElement("span");
              badge.className = "supra-header__cart-count";
              trigger.appendChild(badge);
            }
            if (badge) badge.textContent = String(count);
            if (count === 0) badge?.remove();
            return;
          }

          const label = trigger.querySelector("span");
          if (label) label.textContent = count > 0 ? `Cart (${count})` : "Cart";
        });
      })
      .catch((error) => {
        if (error?.name !== "AbortError")
          console.warn("[supra-header] Cart update promise rejected:", error);
      });
  };

  initializeMegaMenus() {
    this.megaItems.forEach((item) => {
      item.addEventListener("pointerenter", () => {
        window.clearTimeout(this.closeTimer);
        this.openMegaMenu(item);
      });
      item.addEventListener("pointerleave", () => {
        this.closeTimer = window.setTimeout(() => this.closeMegaMenus(), 120);
      });
      item.addEventListener("focusin", () => this.openMegaMenu(item));
      item.addEventListener("focusout", () => {
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) this.closeMegaMenus();
        });
      });
    });
  }

  openMegaMenu(activeItem) {
    this.megaItems.forEach((item) => {
      const open = item === activeItem;
      item.classList.toggle("is-mega-open", open);
      item
        .querySelector("[data-supra-mega-trigger]")
        ?.setAttribute("aria-expanded", String(open));
    });
  }

  closeMegaMenus() {
    this.megaItems.forEach((item) => {
      item.classList.remove("is-mega-open");
      item
        .querySelector("[data-supra-mega-trigger]")
        ?.setAttribute("aria-expanded", "false");
    });
  }

  setOpen(open) {
    this.drawer.hidden = !open;
    this.toggle.setAttribute("aria-expanded", String(open));
    this.header.classList.toggle("is-menu-open", open);
    document.documentElement.classList.toggle("supra-menu-open", open);
    if (open) this.closeButton?.focus();
    this.updateHeightTokens();
  }

  updateHeightTokens() {
    const headerHeight =
      this.header.querySelector(".supra-header__inner")?.offsetHeight || 0;
    const groupHeight =
      document.querySelector("#header-group")?.offsetHeight || headerHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
    document.body.style.setProperty(
      "--header-group-height",
      `${groupHeight}px`,
    );
  }
}

const initializeSupraHeaders = (scope = document) => {
  scope.querySelectorAll("[data-supra-header]").forEach((header) => {
    if (header.dataset.initialized) return;
    header.dataset.initialized = "true";
    new SupraHeader(header);
  });
};

initializeSupraHeaders();
document.addEventListener("shopify:section:load", (event) =>
  initializeSupraHeaders(event.target),
);
